import React, { useState } from 'react';
import { auth, db } from '../../firebase';
import { doc, deleteDoc } from 'firebase/firestore';
import { deleteUser, EmailAuthProvider, reauthenticateWithCredential } from 'firebase/auth';
import { useRole } from '../RoleContext';
import SettingsSidebar from './Sidebar';
import '../App.css';

const DeleteAccount = ({ setPage }) => {
  const [deletePassword, setDeletePassword] = useState('');
  const [verifyDel, setVerifyDel] = useState('');
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');
  const { setRole } = useRole();

  const displayMessage = (msg, type) => {
    setMessage(msg);
    setMessageType(type);
    setTimeout(() => setMessage(''), 4000);
  };

  const handleDeleteAccount = async () => {
    try {
      const user = auth.currentUser;
      if (!user || !deletePassword) {
        displayMessage('Please log in and enter password.', 'error');
        return;
      }
      if (verifyDel !== 'REMOVE') {
        displayMessage("You must type 'REMOVE' to confirm.", 'error');
        return;
      }
      const credential = EmailAuthProvider.credential(user.email, deletePassword);
      await reauthenticateWithCredential(user, credential);
      await deleteDoc(doc(db, 'users', user.uid));
      await deleteUser(user);
      setRole('');
      displayMessage('Account deleted successfully.', 'success');
      window.location.reload();
    } catch (err) {
      displayMessage(`Error: ${err.message}`, 'error');
    }
  };

  const styles = {
    container: { display: 'flex', minHeight: '100vh', background: 'linear-gradient(to right, #fff5f5, #ffeaea)' },
    content: { flexGrow: 1, padding: '3rem', display: 'flex', justifyContent: 'center', alignItems: 'center' },
    card: {
      width: '100%',
      maxWidth: '500px',
      backgroundColor: '#fff',
      borderRadius: '16px',
      boxShadow: '0 6px 25px rgba(0,0,0,0.1)',
      padding: '2.5rem',
    },
    title: { textAlign: 'center', color: '#b71c1c', fontSize: '1.8rem', fontWeight: 700, marginBottom: '25px' },
    input: {
      width: '100%',
      padding: '12px 14px',
      borderRadius: '8px',
      border: '1px solid #ccc',
      fontSize: '1rem',
      marginBottom: '15px',
      transition: 'all 0.2s ease',
    },
    button: {
      width: '100%',
      padding: '12px 20px',
      borderRadius: '10px',
      border: 'none',
      backgroundColor: '#dc3545',
      color: 'white',
      fontWeight: '600',
      fontSize: '1rem',
      cursor: 'pointer',
      transition: 'all 0.2s ease',
    },
    messageBox: (type) => ({
      padding: '12px 18px',
      marginBottom: '20px',
      borderRadius: '8px',
      textAlign: 'center',
      color: type === 'error' ? '#721c24' : '#155724',
      backgroundColor: type === 'error' ? '#f8d7da' : '#d4edda',
      border: `1px solid ${type === 'error' ? '#f5c6cb' : '#c3e6cb'}`,
    }),
  };

  return (
    <div style={styles.container}>
      <SettingsSidebar currentPage="settings/delete" setPage={setPage} />
      <div style={styles.content}>
        <div style={styles.card}>
          <h2 style={styles.title}>Delete Account</h2>

          {message && <div style={styles.messageBox(messageType)}>{message}</div>}

          <input
            type="password"
            placeholder="Enter your password"
            value={deletePassword}
            onChange={(e) => setDeletePassword(e.target.value)}
            style={styles.input}
          />
          <input
            type="text"
            placeholder="Type 'REMOVE' to confirm"
            value={verifyDel}
            onChange={(e) => setVerifyDel(e.target.value)}
            style={styles.input}
          />

          <button
            onClick={handleDeleteAccount}
            style={styles.button}
            onMouseOver={(e) => (e.target.style.backgroundColor = '#b02a37')}
            onMouseOut={(e) => (e.target.style.backgroundColor = '#dc3545')}
          >
            Delete Account
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteAccount;
